import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { Sobre } from 'src/app/models/sobre.model';
import { daApi, MAP_SOBRE, paraApi } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class SobreService {

  constructor(
    public api: ApiService
  ) { }

  get(): Observable<Sobre> {
    return this.api.get('/about').pipe(map((res: any) => res ? daApi(res, MAP_SOBRE) : new Sobre()));
  }

  // Registro unico: o POST da API faz insere-ou-altera.
  patch(sobre: Sobre): Observable<any> {
    return this.api.post('/about', paraApi(sobre, MAP_SOBRE));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}
